import React from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { newsletterAPI } from '../../services/api';

const AdminNewsletterPage = () => {
  const qc = useQueryClient();
  const [subject, setSubject] = React.useState('');
  const [html, setHtml] = React.useState('');

  const { data } = useQuery(['subscribers'], async () => {
    const res = await newsletterAPI.listSubscribers({ limit: 200 });
    return res.data;
  });

  const sendMutation = useMutation((payload) => newsletterAPI.sendNewsletter(payload), {
    onSuccess: () => qc.invalidateQueries(['subscribers'])
  });

  const delMutation = useMutation((id) => newsletterAPI.deleteSubscriber(id), {
    onSuccess: () => qc.invalidateQueries(['subscribers'])
  });

  const subscribers = data?.subscribers || [];

  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-bold text-white">Newsletter</h1>

      <section className="bg-gray-800 border border-gray-700 rounded-xl p-6">
        <h2 className="text-lg font-semibold text-white mb-4">Composer une newsletter</h2>
        <div className="space-y-4">
          <input
            className="w-full px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-white"
            placeholder="Sujet"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
          <textarea
            className="w-full h-40 px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-white"
            placeholder="Contenu HTML (optionnel)"
            value={html}
            onChange={(e) => setHtml(e.target.value)}
          />
          <button
            onClick={() => sendMutation.mutate({ subject, html })}
            disabled={sendMutation.isLoading || !subject}
            className="px-6 py-3 bg-yellow-500 text-gray-900 font-semibold rounded-lg disabled:opacity-60"
          >
            {sendMutation.isLoading ? 'Envoi…' : 'Envoyer à tous les abonnés'}
          </button>
        </div>
      </section>

      <section className="bg-gray-800 border border-gray-700 rounded-xl p-6">
        <h2 className="text-lg font-semibold text-white mb-4">Abonnés ({subscribers.length})</h2>
        <div className="overflow-auto">
          <table className="min-w-full text-sm text-gray-300">
            <thead>
              <tr className="bg-gray-700">
                <th className="text-left px-4 py-2">Email</th>
                <th className="text-left px-4 py-2">Inscription</th>
                <th className="px-4 py-2"></th>
              </tr>
            </thead>
            <tbody>
              {subscribers.map((s) => (
                <tr key={s.id} className="border-t border-gray-700">
                  <td className="px-4 py-2">{s.email}</td>
                  <td className="px-4 py-2">{new Date(s.created_at).toLocaleString('fr-FR')}</td>
                  <td className="px-4 py-2 text-right">
                    <button
                      onClick={() => delMutation.mutate(s.id)}
                      className="px-3 py-1 bg-red-500/80 hover:bg-red-500 text-white rounded"
                    >
                      Supprimer
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default AdminNewsletterPage;


